import { render, staticRenderFns } from "./CompanyAddress.vue?vue&type=template&id=27a4eebc&scoped=true&"
import script from "./CompanyAddress.vue?vue&type=script&lang=js&"
export * from "./CompanyAddress.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAddress.vue?vue&type=style&index=0&id=27a4eebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a4eebc",
  null
  
)

export default component.exports